import { render, staticRenderFns } from "./TheUserEditor.vue?vue&type=template&id=2bcc8c06&"
import script from "./TheUserEditor.vue?vue&type=script&lang=js&"
export * from "./TheUserEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports